import React, { useEffect, useState, Fragment } from 'react';
import { useSelector } from 'react-redux';

import { useActions } from '@mssgme/hooks';
import { Badging } from '@mssgme/ui';

import { useUnreadConversations } from '../../hooks';
import { InboxEventNotifier } from '../../services';

export const InboxObserver = ({ children }) => {
    const { api } = useActions();
    const { updateTimestamp, unreadConversationsCount } = useUnreadConversations();
    const [eventNotifier] = useState(() => new InboxEventNotifier());
    const reconnected = useSelector((state) => state.socket.reconnected);

    useEffect(() => {
        api.listenConnect();
        api.listenDisconnect();
        api.listenReconnect();
        api.listenVerifyVersion(); // TODO: remove
        api.listenNewMessages();
        api.listenCreateConversation();
        api.listenUpdateConversation();
        api.listenPaymentSucceeded();
        api.listenSubscriptionCancelled();
    }, []);

    useEffect(() => {
        function handleActivity() {
            eventNotifier.dismiss();
            document.removeEventListener('mousemove', handleActivity);
        }

        if (updateTimestamp) {
            eventNotifier.notify();
            document.addEventListener('mousemove', handleActivity);
        }
    }, [updateTimestamp, eventNotifier]);

    return (
        <Fragment key={`c-${reconnected}`}>
            {unreadConversationsCount > 0 && <Badging count={unreadConversationsCount} />}
            {children}
        </Fragment>
    );
};

InboxObserver.propTypes = {};
